// extracted by mini-css-extract-plugin
module.exports = {"contain":"index-module_contain_1__HB","item":"index-module_item_3M5zT"};